import styled from "styled-components";

const IconImage = styled.img`
  width: auto;
  height: 40px;
`;

export default IconImage;
